/**
 * Bloque plegable de informacion de la ficha (despacho, ficha tecnica).
 *
 * Es un `<details>` nativo: se abre y se cierra sin JavaScript, el buscador lee
 * el contenido aunque este cerrado y el teclado lo maneja solo.
 */
import type { ReactNode } from 'react';

import { Icono, type NombreIcono } from '../comunes/Icono';

export interface BloqueInfoProps {
  icono: NombreIcono;
  titulo: string;
  /** Los bloques que importan de entrada nacen abiertos. */
  abierto?: boolean;
  children: ReactNode;
}

export function BloqueInfo({ icono, titulo, abierto = true, children }: BloqueInfoProps) {
  return (
    <details className="bloque-info" open={abierto}>
      <summary className="bloque-info-cab">
        <Icono nombre={icono} />
        {titulo}
      </summary>
      <div className="bloque-info-cuerpo">{children}</div>
    </details>
  );
}
